<template>
<div class="chapter">
<div class="inner_page">
<p class="cip-break"><a id="pIV"></a>Published with assistance from the Annie Burr Lewis Fund.</p>
<p class="cip"> </p>
<p class="cip">Copyright © 2019 John Hardman</p>
<p class="cip"> </p>
<p class="cip">First published in paperback in 2021</p>
<p class="cip"> </p>
<p class="cip">All rights reserved. This book may not be reproduced in whole or in part, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press) without written permission from the publishers.</p>
<p class="cip"> </p>
<p class="cip">For information about this and other Yale University Press publications, please contact:</p>
<p class="cip">U.S. Office:  <a href="mailto:sales.press@yale.edu">sales.press@yale.edu</a>  <a href="http://yalebooks.com" target="_blank">yalebooks.com</a></p>
<p class="cip">Europe Office:  <a href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a>  <a href="http://yalebooks.co.uk" target="_blank">yalebooks.co.uk</a></p>
<p class="cip"> </p>
<p class="cip">Set in Minion Pro by IDSUK (DataConnection) Ltd</p>
<p class="cip">Printed in Great Britain by Clays Ltd, Elcograf S.p.A</p>
<p class="cip"> </p>
<p class="cip">Library of Congress Control Number:  2019941055</p>
<p class="cip"> </p>
<p class="cip">ISBN 978-0-300-24308-6 (hbk)</p>
<p class="cip">ISBN 978-0-300-26094-6 (pbk)</p>
<p class="cip"> </p>
<p class="cip">A catalogue record for this book is available from the British Library.</p>
<p class="cip"> </p>
<p class="cip">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?132bd594